
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { Observable, map } from 'rxjs';
import { UserBankAccountList } from '../models';

@Injectable({
	providedIn: 'root'
})

export class UserBankAccountsResolverService  {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private http: HttpClient,
		private utilsService: UtilsService
	) { }
	resolve(): Observable<UserBankAccountList> {
		return this.http
			.get<UserBankAccountList[]>(`${this.appConfig.apiEndpoint}/new-core/bank-accounts/select?withPending=true`)
			.pipe(map(this.utilsService.handleResponse));
	}
}
